import { map } from 'rxjs/operators';
import { TransactionActionResult } from './../models/transaction-action-result';
import { Injectable } from '@angular/core';
import { AjaxDataServiceService } from '@admin/core/ajax-data-service.service';
import { UrlConfigContainer } from '@admin/core/url-config';
import { PagingFilter } from '@admin/shared/models/paging-filter.model';
import { EmptyData } from '@admin/core/models/empty-data';
import { Observable } from 'rxjs';
import {
  NewPagingWrapper,
  PagingWrapper,
} from '@admin/core/models/paging-wrapper';
import { TransactionListItemModel } from '@admin/billing/transactions/shared/models/transaction-list-item-model';
import { TransactionListTotalsModel } from '@admin/billing/transactions/shared/models/transaction-list-totals';
import { TransactionListFilterModel } from '@admin/billing/transactions/shared/models/transaction-list-filter-model';
import { TransactionPayerCustomerModel } from '../models/transaction-payer-customer-model';
import { TransactionEditSubmitDataModel } from '../models/transaction-edit-submit-data-model';
import { CommonLookupItem } from '../../../../shared/models/common-lookup-item.model';
import { SendInvoiceRequestModel } from '@admin/billing/shared/send-invoice-request-model';
import { SendInvoiceResultModel } from '@admin/billing/shared/send-invoice-result-model';
import { ActionResultModel } from '../../../../shared/models/action-result-model';
import { NewAjaxDataServiceService } from '@admin/core/new-ajax-data.service';
//import { PagingWrapperNew } from '@admin/core/models/paging-wrapper';
import { ApiResponse } from '../../../../core/api-response';
import { UrlConfigService } from '@hrra/core';

@Injectable()
export class TransactionListService {
  constructor(
    private ajax: AjaxDataServiceService,
    private newAjax: NewAjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>
  ) {}

  private buildTransactionFilterData(filter: TransactionListFilterModel) {
    return {
      TransactionCode: filter.transactionCode,
      InvoiceCode: filter.invoiceCode,
      CustomerCredential: filter.customerCredential,
      AccountManagerId: filter.accountManagerId,
      ProductTypeId: filter.productTypeId,
      PaymentTypeId: filter.paymentTypeId,
      DisplayRejectedAndCanceled: filter.displayRejectedAndCanceled,
      DisplayOnlyWithoutFinalApproval: filter.displayOnlyWithoutFinalApproval,
      DisplayOnlyWithoutInitialCompleteApproval:
        filter.displayOnlyWithoutInitialCompleteApproval,
      DisplayZeroInvoices: filter.displayZeroInvoices,
      CreateDate: filter.createDate,
      ApproveDate: filter.approveDate,
      PortfolioIdList: filter.portfolioId != null ? [filter.portfolioId] : [],
      Start: filter.start,
      SortParameters: filter.sortParameters,
    };
  }

  public listTransactions(
    filter: TransactionListFilterModel
  ): Observable<ApiResponse<NewPagingWrapper<TransactionListItemModel>>> {
    const data = this.buildTransactionFilterData(filter);
    return this.newAjax.postDataPaging<TransactionListItemModel>(
      this.urlService.urlConfig.api.data.transactions.list,
      data
    );
  }

  public getTransactionsTotalAmounts(
    filter: TransactionListFilterModel
  ): Observable<ApiResponse<TransactionListTotalsModel>> {
    const data = this.buildTransactionFilterData(filter);
    return this.newAjax.postData<TransactionListTotalsModel>(
      this.urlService.urlConfig.api.data.transactions.totals,
      data
    );
  }

  public listPayers(text: string) {
    let data = {
      autoCompleteText: text,
    };
    return this.ajax
      .getDataPaging(
        this.urlService.urlConfig.api.data.transactions.payers.list,
        data,
        CommonLookupItem<number, string>
      )
      .pipe(map((p) => p.items));
  }

  public editTransaction(data: TransactionEditSubmitDataModel) {
    let postData = {
      TransactionRecordId: data.transactionRecordId,
      PayerAccountId: data.payerAccount.id,
      InvoiceAmount: data.invoiceAmount,
      PaymentType: data.paymentType,
    };
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.transactions.edit,
      postData,
      ActionResultModel
    );
  }

  public sendConfirmation(data: SendInvoiceRequestModel) {
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.transactions.sendConfirmation,
      data,
      SendInvoiceResultModel
    );
  }

  public approveTransactionInitial(
    transactions: TransactionListItemModel[],
    isPartial: boolean
  ) {
    let data = {
      TransactionIds: transactions.map((t) => t.transactionRecordId),
      IsPartial: isPartial,
    };
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.transactions.approve.initial,
      data,
      TransactionActionResult
    );
  }

  public approveTransactionFinal(transactions: TransactionListItemModel[]) {
    let data = {
      TransactionIds: transactions.map((t) => t.transactionRecordId),
    };
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.transactions.approve.final,
      data,
      TransactionActionResult
    );
  }

  public rejectUnapprovedTransaction(transactions: TransactionListItemModel[]) {
    let data = {
      TransactionIds: transactions.map((t) => t.transactionRecordId),
    };
    return this.ajax.postData(
      this.urlService.urlConfig.api.data.transactions.reject,
      data,
      TransactionActionResult
    );
  }
}
